import React, {useMemo} from "react";
import {useTalentCandidateScope} from "./TalentCandidateScopeProvider";

const CandidateConfirmPayoutForm = ({buttonClass = 'btn-primary',...props}) => {

    const {
        candidate,
        isLoading,
        isDisabled,
        updateCandidateScope
    } = useTalentCandidateScope();

    const acceptPayoutBtnClass = useMemo(() => {
        return TB.mapClass("btn text-xs self-center whitespace-nowrap", {
            [buttonClass]: true,
            "disabled-edit-link": !candidate.canAcceptPayout()
        })
    }, [candidate, isDisabled]);

    const updatePayout = async () => {
        if (isDisabled) {
            return
        }

        let updates = {payout_confirmed_at: candidate.hasConfirmedPayout() ? null : new Date()};

        if (!candidate.canAcceptPayout()) {
            await TB.alert('warning', 'Candidate Still Pending',
                'The candidate hasn\'t submitted their proposal. Candidate\'s must accept their payout before you can confirm the candidate\'s payout', [
                {title: 'Ok'},
            ]);

            return;
        }
        if (!candidate.job_candidate.matches_payout) {

            let confirm = await TB.alert('warning', 'Candidate has Proposed Payout',
                'The candidate has proposed a different payout that what was scoped. Are you sure you want to confirm payout and allow the candidate\'s proposal to be viewed by the client?', [
                    {title: 'Yes, Continue'},
                    {title: 'Cancel'},
                ]);
            if (!confirm) {
                return;
            }
        }
        return updateCandidateScope(updates)
    };
    if (isLoading || !candidate) {
        return null
    }
    if (candidate.hasConfirmedPayout()) {
        return (
            <div className="flex flex-row items-center gap-0.5">
                <p className="text-xs py-1 px-1.5 self-center whitespace-nowrap flex flex-row items-center gap-1.5">
                    <i className="fas fa-check-circle text-success"/>
                    <span>Payout Accepted</span>
                </p>
                {/*<button className="text-xxs py-1 px-1.5 self-center whitespace-nowrap btn-link btn-link-primary" disabled={isDisabled}*/}
                {/*        onClick={updatePayout}>*/}
                {/*    Undo*/}
                {/*</button>*/}
            </div>
        )
    }

    return (
            <button className={acceptPayoutBtnClass} disabled={isDisabled}
                    onClick={updatePayout}>
                Accept Payout
            </button>
    )
}

export default CandidateConfirmPayoutForm